import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  error: string;
  password;

  firstName;
  lastName

  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.firstName = this.route.snapshot.queryParamMap.get('firstName');
    this.lastName = this.route.snapshot.queryParamMap.get('lastName');
  }

  setPasswordAction() {
    let token = this.route.snapshot.queryParamMap.get('token');
    let userId = this.route.snapshot.queryParamMap.get('userId');

    this.authService.resetPassword(token, userId, this.password).then((res) => {
      if(this.authService.isAuthenticated()) {
        if(this.authService.isAdmin()) {
          this.router.navigate(['/admin-landing']);
        } else {
          this.router.navigate(['/lessee-landing']);
        }
      }
    }).catch((err) => {
      this.error = 'This link has expired. Please request another one.';
    });
  }

  loginWithAmazonAction() {
    window['amazon'].Login.authorize({ scope : 'profile' }, 'http://localhost:4200/amazonSignUp')
  }
}
